import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AudioElement from 'containers/AudioElement/AudioElementContainer';
import AudioSourceDropdownComp from 'components/SourceDisplay/AudioSourceDropdown';
import incomingRing from 'assets/audio/incoming-ring.mp3';
import classes from 'components/SourceDisplay/SourceDisplay.module.scss';

class SpeakerDropdown extends React.Component {
  UNSAFE_componentWillMount() {
    this.setState({ isRinging: false });
  }

  startRinging = () => {
    this.setState({ isRinging: true });
    setTimeout(() => {
      this.setState({ isRinging: false });
    }, 4600);
  };

  titleText = () => {
    if (this.props.titleClass) {
      return (
        <span className={this.props.titleClass}>
          <FormattedMessage
            id="components.avSettingsModal.speakers"
            defaultMessage="Speakers"
          />
        </span>
      );
    }

    if (this.props.isJoinFlowCall) {
      return (
        <FormattedMessage
          id="components.avSettingsModal.selectSpeaker"
          defaultMessage="Select your speakers"
        />
      );
    }

    return (
      <FormattedMessage
        id="components.avSettingsModal.speaker"
        defaultMessage="Speaker settings"
      />
    );
  };

  renderAudioTag() {
    if (!this.state.isRinging) return <audio />;
    return (
      <AudioElement
        src={incomingRing}
        loop
        autoPlay
        preload={'auto'}
        type={'audio/mp3'}
        audioOutputDeviceId={this.props.selectedAudioOutputId}
      />
    );
  }

  render() {
    if (this.props.isPSTNVisible) return null;
    return (
      <div className={classes.speakerDropdown}>
        <div className={classes.subHeading}>
          {this.titleText()}
        </div>
        <div className={classes.dropdownContainer} >
          {this.props.audioOutputDevices.length ?
            <AudioSourceDropdownComp
              audioDevices={this.props.audioOutputDevices}
              selectAudioSource={this.props.selectAudioOutput}
              defaultAudioSetting={this.props.defaultAudioSetting}
              defaultVideoSetting={this.props.defaultVideoSetting}
              selectedAudioLabel={this.props.selectedAudioOutputLabel}
              dataTestId="speaker-dropdown"
            />
            :
            <div className={classes.emptyDropdown}>
              <FormattedMessage
                id="components.avSettingsModal.noSpeakers"
                defaultMessage="No speakers detected"
              />
            </div>
          }
        </div>
        {!this.props.isInCall && <button className={classes.playTest} onClick={this.startRinging} data-testid="speaker-test-link">
          <FormattedMessage
            id="components.avSettingsModal.playTest"
            defaultMessage="Test my speakers"
          />
        </button>}
        {this.renderAudioTag()}
      </div>);
  }
}

SpeakerDropdown.propTypes = {
  isPSTNVisible: PT.bool,
  isJoinFlowCall: PT.bool,
  audioOutputDevices: PT.array,
  selectAudioOutput: PT.func,
  defaultVideoSetting: PT.bool,
  defaultAudioSetting: PT.bool,
  isRinging: PT.bool,
  selectedAudioOutputId: PT.string,
  selectedAudioOutputLabel: PT.string,
  isInCall: PT.bool,
  titleClass: PT.string
};

export default SpeakerDropdown;
